













export default {
  name: 'Dialog'
  props: [
    'show'
  ]

  watch:
    'show': (show) ->
      if show 
        @$el.show() 
        @$emit 'open'
      else
        @$el.close()
}   




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/dialog/Dialog.vue